export const iconFontAwesomeEnergySolarPanel = (
	<i className="fa-solid fa-solar-panel"></i>
);
